import Styles from './useIntegrationMaintenanceBanner.module.scss'
import { useCurrentWorkspace } from 'hooks/useCurrentWorkspace'
import { Text } from 'blaze-ui/Text/Text'
import { AlertTriangle } from 'blaze-ui/icons'
import type { IntegrationMaintenanceBanner } from 'types'
import useResponsiveDesign from 'hooks/useResponsiveDesign'
import { useAPMobileWeb } from 'hooks/useAPMobileWeb'

export const useIntegrationMaintenanceBanner = () => {
  const workspace = useCurrentWorkspace()
  const { isIOSNative } = useResponsiveDesign()
  const isAPMobileWeb = useAPMobileWeb()

  const banners: IntegrationMaintenanceBanner[] = workspace?.integration_maintenance_banners || []
  const showBanner = banners.length > 0 && !isIOSNative && !isAPMobileWeb

  // Calculate dynamic height based on number of banners
  const bannerHeight = 37
  const totalHeight = banners.length * bannerHeight

  const integrationMaintenanceBanner = (
    <div className={Styles.container}>
      {banners.map((banner) => (
        <div key={banner.provider} className={Styles.banner}>
          <AlertTriangle color="var(--red-70)" size={20} />
          <div className={Styles.message}>
            <Text variant="secondary" color="var(--red-70)">
              {banner.message}
            </Text>
          </div>
        </div>
      ))}
    </div>
  )

  return {
    showBanner,
    integrationMaintenanceBanner,
    totalHeight,
  }
}
